import { render, staticRenderFns } from "./smartDigitalService.vue?vue&type=template&id=28f4d9e4&scoped=true"
import script from "./smartDigitalService.vue?vue&type=script&lang=js"
export * from "./smartDigitalService.vue?vue&type=script&lang=js"
import style0 from "./smartDigitalService.vue?vue&type=style&index=0&id=28f4d9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4d9e4",
  null
  
)

export default component.exports